import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.COLD_STORAGE_UPLOAD,
  displayName: "Cold Storage Upload",
  isCustomerFacing: false,
};

export default entitlement;
